module.exports = {"220621100":"抚松镇","220621101":"松江河镇","220621102":"泉阳镇","220621103":"露水河镇","220621104":"仙人桥镇","220621105":"万良镇","220621106":"新屯子镇","220621107":"东岗镇","220621108":"漫江镇","220621109":"北岗镇","220621110":"兴参镇","220621120":"长白山保护开发区管委会池西区（特殊乡镇）","220621121":"长白山保护开发区管委会池南区（特殊乡镇）","220621200":"兴隆乡","220621201":"抽水乡","220621202":"沿江乡","220621407":"抚松工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220621.json
// module id = 593
// module chunks = 0